export default __webpack_public_path__ + "static/media/statistic.ecd43232.svg";